// extracted by mini-css-extract-plugin
export default {"container":"PatiendCard_container__maBGF","text":"PatiendCard_text__2WDTf"};